import { useQuery } from "@tanstack/react-query"
import { medicalsAllergiesQueryOptions, medicalsConditionsQueryOptions } from "../api/queries"
import { useConditionModal } from "../store/condition-modal"
import { useAllergyModal } from "../store/allergy-modal"
import { AllergiesCard } from "./components/allergies-card"
import { EmptyMedicalCard } from "./components/empty-medical-cards"
import { HealthConditionCard } from "./components/health-condition-card"
import { Modal } from "~/features/dashboard/components/modal"
import { ConditionForm } from "./components/forms/condition-form"
import { AllergyForm } from "./components/forms/allergy-form"
import { useParams } from "@tanstack/react-router"

// Skeleton card for loading state
function CardSkeleton() {
  return (
    <div className="flex-1 min-w-[300px] h-40 bg-gray-200 rounded-lg animate-pulse" />
  );
}

export function ConditionsAllergiesPage() {
    const { program } = useParams({ strict: false })
    const conditionsQuery = useQuery(medicalsConditionsQueryOptions(program === 'weight-loss' ? 'weight_loss' : 'urgent_care'))
    const allergiesQuery = useQuery(medicalsAllergiesQueryOptions(program === 'weight-loss' ? 'weight_loss' : 'urgent_care'))

    const { isOpen: isConditionModalOpen, open: openConditionModal, close: closeConditionModal } = useConditionModal()
    const { isOpen: isAllergyModalOpen, open: openAllergyModal, close: closeAllergyModal } = useAllergyModal()

    return (
        <>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {conditionsQuery.isLoading ? (
                  <CardSkeleton />
                ) : conditionsQuery.data?.conditions && conditionsQuery.data?.conditions?.length > 0 ?
                    <HealthConditionCard items={conditionsQuery.data?.conditions} onButtonClick={() => { openConditionModal() }} totalCount={conditionsQuery.data?.conditions?.length} /> :
                    <EmptyMedicalCard
                        title="Health Conditions"
                        description="No medical conditions listed."
                        icon={<h1 className="text-[32px]">📑</h1>}
                        message={`If you don't have any, no action is needed. Otherwise, please update your medical history to help us provide safe and effective care.`}
                        showButton={true}
                        buttonText="Add conditions"
                        onButtonClick={() => { openConditionModal() }}
                    />}

                {allergiesQuery.isLoading ? (
                  <CardSkeleton />
                ) : allergiesQuery.data?.allergies && allergiesQuery.data?.allergies?.length > 0 ?
                    <AllergiesCard items={allergiesQuery.data?.allergies} onButtonClick={() => { openAllergyModal() }} totalCount={allergiesQuery.data?.allergies?.length} /> :
                    <EmptyMedicalCard
                        title="Allergies"
                        description="No allergies listed."
                        icon={<h1 className="text-[32px]">🦠</h1>}
                        message={`Let us know if you have any allergies so we can avoid potential risks in your treatment plan. `}
                        showButton={true}
                        buttonText="Add allergies"
                        onButtonClick={() => { openAllergyModal() }}
                    />}
            </div>
            <Modal isOpen={isConditionModalOpen} onClose={closeConditionModal} title={"Add Medical condition"}>
                <ConditionForm onClose={closeConditionModal} />
            </Modal>
            <Modal isOpen={isAllergyModalOpen} onClose={closeAllergyModal} title={"Add Allergy"}>
                <AllergyForm onClose={closeAllergyModal} />
            </Modal>
        </>
    )
}
